module.exports = __webpack_public_path__ + "static/img/ic_annual_bonus.92558ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welfare/ic_annual_bonus.png
// module id = LiTC
// module chunks = 1